import React from 'react'
import { useInitializeNotification } from '../../Hooks'

/**
 * Компонент для ініціалізації глобальних сервісів
 * Має бути розміщений всередині <App> компонента
 */
export const ServiceInitializer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    // Ініціалізуємо NotificationService з Ant Design App.useApp()
    useInitializeNotification()
    
    return <>{children}</>
}
